import { useEffect, useState } from 'react';
import { BASE_URL } from '../constants/urls';
import axios from 'axios';

const useCategoryList = () => {

    const [categoryRegularList, setCategoryRegularList] = useState([]);
    const [categorySeasonalList, setCategorySeasonalList] = useState([]);
    const [categoryProductList, setCategoryProductList] = useState([]);
    const [loadingCategoryList, setLoadingCategoryList] = useState(true);
    const [errorCategoryList, setErrorCategoryList] = useState(null);

    useEffect(() => {

        const fetchCategoryList = async () => {
            try {
                const res = await axios.get(`${BASE_URL}/store-category/names-list`, {
                    headers: { Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`}
                });
                setCategoryRegularList(res.data.regular)
                setCategorySeasonalList(res.data.seasonal)
                setCategoryProductList(res.data.product)
            } catch (err) {
                const msg = err?.response?.data?.message || err.message || 'Erro desconhecido';
                errorCategoryList(msg);
            } finally {
                setLoadingCategoryList(false);
            }
        };

        fetchCategoryList();
    }, []);

    return { categoryRegularList, categorySeasonalList, categoryProductList, loadingCategoryList, setErrorCategoryList };
}

export default useCategoryList